export default __webpack_public_path__ + "static/media/grayPen.be192283.svg";